import React, { useEffect, useState } from "react";
import Pagination from '../../../components/Pagination';
import Loader from '../../../components/Loader';
import EditableTable from "./AgencySubCategoryTable";
import Modal from "../../../components/Modal"
import ChangeLog from "../../../components/ChangeLog";
import api from "../../../auth/api";
import { alertSuccess, alertError } from "../../../components/Alert";
import Add from "./AddAgencySubCategory"

export default function AgencyCategory() {
  const [data, setData] = useState([]);
  const [changeLogData,setChangeLogData] = useState([])
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  const itemsPerPage = 10;
  const editableFields = ['title', 'status'];
  const [addDis, setAddDis] = useState(false);

  useEffect(() => {
    fetchData();
    // getAgencyCategoryList();
    // getAgencySubCategoryList()
  }, []);

  // const getAgencyCategoryList = async () => {
  //   try {
  //     const response = await api.get("/redeem/panel/Category");
  //     setAgencyCategoryList(response.data.result);
  //     console.log(response.data.result)
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } 
  // };

  // const getAgencySubCategoryList = async () => {
  //   try {
  //     const response = await api.get("/redeem/panel/SubCategory");
  //     setAgencySubCategoryList(response.data.result);
  //     console.log(response.data.result)

  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } 
  // };

  const fetchData = async () => {
    try {
      const response = await api.get("/redeem/panel/SubCategory");
      setData(response.data.result);
      setChangeLogData(response.data.Change_Log)
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = data.find((item) => item.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
    try {
      const finalData = {
        id:editedData.id,
        title:editedData.title,
        status:editedData.status
      }
      console.log(finalData)
      const resp = await api.patch(`/redeem/panel/SubCategory`,finalData);
      let succMess = resp.data.success;
      alertSuccess(succMess);
      setEditRowId(null);
      fetchData();
    } catch (error) {
      alertError(error?.response?.data?.errors)
      console.error("Error updating data:", error);
    }

  };

  const handleAdd = async () => {
    setAddDis(true)
  };

  const handleLog = (id) => {
    const logData = changeLogData.filter((f) => f.id === id)[0]
      ?.oldTrack;
    console.log(JSON.stringify(logData));
    setCurrentLog(logData);
    setIsModalOpen(true)
  };


  
  const handleChange = (e, field, val) => {
    if (field === "is_active" || field === "editable" || field === "optional" || field === "status") {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };


  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const headers = data.length > 0 ? Object.keys(data[0]).filter(key => key !== 'id') : [];

  const handleUploadImage = (row)=>{
    console.log(row.id);
    alert(row.id)
  }


  if (loading) return <Loader />;

  return (
    <div className="w-full flex items-center flex-col">
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        editableFields={editableFields}
        handleChange={handleChange}
        handleLog={handleLog}
        handleUploadImage={handleUploadImage}
        fetchData={fetchData}
      />
      <div className="flex mt-4 items-center justify-between w-11/12">
        <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} />
        <button className="activeBtn text-sm text-white py-1 px-2 rounded" onClick={handleAdd}>
          + Add Agency Sub Category
        </button>
      </div>

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Change Log" content={<ChangeLog data={currentLog} />} />

      <Modal isOpen={addDis} onClose={()=>setAddDis(false)} title="Add agency sub category" content={<Add onSuccess={fetchData} />}/>

    </div>
  );
}
